import { useTranslation } from 'react-i18next';
import Image2 from '../assets/video2.mp4';

const Argument = () => {
  const { t } = useTranslation();

  return (
    <section className="arg-section md:space-x-16"  id="inicio">
       <div className="max-w-[300px] md:max-w-[250px]  arg-img-container">
       <video 
        src={Image2} 
        autoPlay 
        loop 
        muted 
        playsInline 
        alt="Video" 
        style={{
          display: "block",
          margin: "0 auto",
          padding: 0,
          objectFit: "cover"
        }}
        ref={(video) => {
          if (video) video.playbackRate = 0.6; // Cambia este valor para ajustar la velocidad
        }}
      >
        Your browser does not support the video tag.
      </video>
      </div> 
      <div className="arg-content" >
          <div className="resp-h4 font-bold">
            <h2 className="font-sans font-bold text-pinkmedium2  font-semibold text-h3 mb:resp-h4">
              {t('argument.title1')}
            </h2>
            <h2 className="font-sans font-bold text-pinkmedium1 font-semibold text-h3 mb:resp-h4">
              {t('argument.title2')}
            </h2>
            <h2 className="font-sans font-bold text-pink font-semibold text-h3 mb:resp-h4">
              {t('argument.title3')}
            </h2>
          </div>
          <div className='mt-4 space-y-8 mb:space-y-4 '>
            <h2 className="font-archivo text-dark font-bold text-h3 mb:resp-h4">
              {t('argument.subtitle')}
            </h2>
            <p
              className="hero-p resp-h2"
              dangerouslySetInnerHTML={{ __html: t('argument.description') }}
            />
            <button 
              className="font-archivo btn-primary resp-body5"
              onClick={() => {
                document.getElementById('contacto').scrollIntoView({ behavior: 'smooth' });
              }}
            >
              {t('argument.contact_btn')}
            </button>
          </div>
      </div>
    </section>
  );
};

export default Argument;
